var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminIntro4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 167,
    viewBox: "0 0 134 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.378906 25C0.378906 11.1929 11.5718 0 25.3789 0H108.113C121.921 0 133.113 11.1929 133.113 25V106.292C133.113 120.099 121.921 131.292 108.113 131.292H0.378906V25Z",
    fill: "url(#paint0_linear_623_6046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8789 30.4512C35.2515 30.4512 29.8789 35.8237 29.8789 42.4512V87.9157C29.8789 94.5431 35.2515 99.9157 41.8789 99.9157H93.4215C100.049 99.9157 105.422 94.5431 105.422 87.9157V42.4512C105.422 35.8238 100.049 30.4512 93.4215 30.4512H41.8789ZM48.6241 66.8773L58.5147 77.6595L86.6757 46.9909C87.2082 46.409 87.9312 46.082 88.6851 46.082C89.4391 46.082 90.1621 46.409 90.6946 46.9909C91.8062 48.2027 91.8062 50.1603 90.6946 51.3721L60.5384 84.2469C59.4268 85.4588 57.6311 85.4588 56.5195 84.2469L44.6052 71.2586C43.4936 70.0467 43.4936 68.0892 44.6052 66.8773C45.1377 66.2955 45.8607 65.9685 46.6147 65.9685C47.3686 65.9685 48.0916 66.2955 48.6241 66.8773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3855 167.001L0.378906 131.293H47.9902L66.3855 167.001Z",
    fill: "url(#paint1_linear_623_6046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_6046",
    x1: 120.129,
    y1: -0.00000117311,
    x2: 0.378907,
    y2: 131.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CD1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_6046",
    x1: 16.2493,
    y1: 128.047,
    x2: 66.7462,
    y2: 167.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CD1F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIntro4);
export default __webpack_public_path__ + "static/media/adminIntro4.a7832818f51eabd1a68958fb90ff86ee.svg";
export { ForwardRef as ReactComponent };